/**
 * Format product data for CEDDL tracking
 *
 * @param {object} param0
 * @param {string} [param0.prid]
 * @param {'1' | '3' | null} [param0.catalog]
 * @param {string | null} [param0.offer]
 * @param {number | null} [param0.quantity]
 * @param {string | null} [param0.availability]
 * @param {string | null} [param0.nature]
 * @param {string[] | null} [param0.eqNatures]
 * @param {string[] | null} [param0.sellerTypes]
 * @param {string | null} [param0.condition]
 * @param {string | null} [param0.fulfillment]
 * @param {string | null} [param0.sellerId]
 * @param {string | null} [param0.sellerLocation]
 * @param {string | null} [param0.sellerName]
 * @param {string | null} [param0.sellerType]
 */
export default function digitalDataProduct({
  prid,
  catalog,
  offer,
  quantity,
  availability,
  nature,
  eqNatures = [],
  sellerTypes = [],
  condition,
  fulfillment,
  sellerId,
  sellerLocation,
  sellerName,
  sellerType
}) {
  return {
    attributes: {
      catalog: catalog === '3' ? 'metacat' : 'newref',
      offerID: offer,
      availabilityID: availability,
      offer: sellerTypes.map((type) => ({
        sellerType: type
      })),
      nature,
      condition,
      fulfillment,
      sellerID: sellerId,
      sellerName,
      sellerLocation,
      sellerType
    },
    productInfo: {
      productID: prid
    },
    linkedProduct: eqNatures.map((eqNature) => ({
      attributes: {
        catalog: catalog === '3' ? 'metacat' : 'newref',
        nature: eqNature
      },
      productInfo: {
        productID: prid
      }
    })),
    quantity
  };
}
